import React from "react";
import styles from "./Footer.module.css";
import { NavLink, useNavigate } from "react-router-dom";
import { Logo } from "../../../components/logo/Logo";

export const Footer = () => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    // Check if we're on the landing page
    if (window.location.pathname === '/') {
      // Scroll to top smoothly
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // Navigate to landing page and scroll to top
      navigate('/');
      // Use setTimeout to ensure navigation completes before scrolling
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  };

  const handleSectionClick = (e, sectionId) => {
    e.preventDefault();
    if (window.location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  const handlePricingClick = (e) => {
    e.preventDefault();
    navigate('/pricing');
  };

  return (
    <footer className={ styles.footer }>
      <div className={ styles.container }>
        <div className={ styles.footerContent }>
          <div className={ styles.logoSection }>
            <div onClick={ handleLogoClick } style={ { cursor: 'pointer', width: 'fit-content' } }>
              <Logo className={ styles.logo } />
            </div>
            <p className={ styles.description }>
              AI Note-Taking & Conversation Intelligence Built for Sales Teams
            </p>
          </div>

          <div className={ styles.linksSection }>
            <div className={ styles.linkColumn }>
              <h4 className={ styles.linkTitle }>Product</h4>
              <ul className={ styles.linkList }>
                <li><a href="#features" onClick={ (e) => handleSectionClick(e, 'features') }>Features</a></li>
                <li><a href="/pricing" onClick={ handlePricingClick }>Pricing</a></li>
                <li><a href="https://calendly.com/viraj-galile/30min" target="_blank" rel="noopener noreferrer">Book Demo</a></li>
              </ul>
            </div>

            <div className={ styles.linkColumn }>
              <h4 className={ styles.linkTitle }>Company</h4>
              <ul className={ styles.linkList }>
                <li><a href="#team" onClick={ (e) => handleSectionClick(e, 'team') }>Meet the Team</a></li>
                <li><NavLink to="/contact">Contact</NavLink></li>
              </ul>
            </div>

            <div className={ styles.linkColumn }>
              <h4 className={ styles.linkTitle }>Legal</h4>
              <ul className={ styles.linkList }>
                <li><NavLink to="/privacy-policy">Privacy Policy</NavLink></li>
                <li><NavLink to="/terms-of-service">Terms of Service</NavLink></li>
              </ul>
            </div>
          </div>
        </div>

        <div className={ styles.footerBottom }>
          <p className={ styles.copyright }>
            © 2026 Galile Technologies Private Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
